var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame47(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4B0082"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 24.1667V18.3333M27.5 16.6667V23.3333C27.5 24.4384 27.061 25.4982 26.2796 26.2796C25.4982 27.061 24.4384 27.5 23.3333 27.5H16.6667C15.5616 27.5 14.5018 27.061 13.7204 26.2796C12.939 25.4982 12.5 24.4384 12.5 23.3333V16.6667C12.5 15.5616 12.939 14.5018 13.7204 13.7204C14.5018 12.939 15.5616 12.5 16.6667 12.5H23.3333C24.4384 12.5 25.4982 12.939 26.2796 13.7204C27.061 14.5018 27.5 15.5616 27.5 16.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1668 24.1667V21.4584M19.1668 21.4584V18.3334M19.1668 21.4584C19.1668 18.3334 24.1668 18.3334 24.1668 21.4584V24.1667M15.8335 15.8417L15.8418 15.8325",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame47);
export default __webpack_public_path__ + "static/media/Frame 47.d434c8fe3b5b25798d96c60c78598ae1.svg";
export { ForwardRef as ReactComponent };